"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeFilter = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("@veeam/components");
const core_1 = require("@veeam/core");
const core_2 = require("../../../../../../core");
const TypeFilterModel_1 = require("./TypeFilterModel");
require("./types");
const TypeFilterButton = styled_components_1.default(components_1.LinkButton) `
  padding: 0 8px;
  background-color: ${(props) => props.isActive ? props.theme.colors.backgrounds.selection + '!important' : undefined};
  &,
  &:hover,
  &:active,
  &:focus {
    text-decoration: none;
  }
  &:hover,
  &:active,
  &:focus {
    background-color: ${(props) => props.theme.colors.backgrounds.hover};
  }
  color: ${(props) => (props.isActive ? props.theme.fonts.colors.primary : undefined)};
`;
const TypeFilter = ({ model }) => {
    const { t } = core_2.useFeatureContext();
    const handleButtonClick = (type) => {
        model.update((value) => {
            value.type = type;
        });
    };
    const { value } = core_1.useModel(model);
    return (react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, align: components_1.STACK_ALIGN.center, gap: components_1.STACK_GAP.s },
        react_1.default.createElement(components_1.Label, null, t('dashboard|topPolicies|header|filter|type|label')),
        react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, align: components_1.STACK_ALIGN.center },
            react_1.default.createElement(TypeFilterButton, { onClick: () => handleButtonClick(TypeFilterModel_1.TOP_POLICY_WIDGET_TYPES.snapshot), isActive: TypeFilterModel_1.TypeFilterModel.isSnapshotType(value.type) }, t('dashboard|topPolicies|header|filter|type|snapshot')),
            react_1.default.createElement(TypeFilterButton, { onClick: () => handleButtonClick(TypeFilterModel_1.TOP_POLICY_WIDGET_TYPES.backup), isActive: TypeFilterModel_1.TypeFilterModel.isBackupType(value.type) }, t('dashboard|topPolicies|header|filter|type|backup')),
            react_1.default.createElement(TypeFilterButton, { onClick: () => handleButtonClick(TypeFilterModel_1.TOP_POLICY_WIDGET_TYPES.archive), isActive: TypeFilterModel_1.TypeFilterModel.isArchiveType(value.type) }, t('dashboard|topPolicies|header|filter|type|archive')))));
};
exports.TypeFilter = TypeFilter;
//# sourceMappingURL=TypeFilter.js.map